(function () {
  'use strict';

  document.querySelectorAll('.rizzy2-pdp').forEach(initRizzy2Pdp);

  function initRizzy2Pdp(root) {
    var form = root.querySelector('.rizzy2-pdp__form');

    if (form) {
      var variantInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector('[data-rizzy2-price]');
      var addPriceEl = form.querySelector('[data-rizzy2-add-price]');
      var qtyInput = form.querySelector('input[name="quantity"]');

      var currentUnitPriceCents = (addPriceEl && addPriceEl.dataset.unitPriceCents)
        ? parseInt(addPriceEl.dataset.unitPriceCents, 10)
        : 0;

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function currentQty() {
        var val = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        return (!val || val < 1) ? 1 : val;
      }

      function updateAddToCartPrice() {
        if (!addPriceEl) return;
        addPriceEl.textContent = formatMoney(currentUnitPriceCents * currentQty());
      }

      /* Pack size selector */
      root.querySelectorAll('[data-rizzy2-pack]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.available === 'false') return;
          root.querySelectorAll('[data-rizzy2-pack]').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          if (variantInput) variantInput.value = btn.dataset.variantId;

          currentUnitPriceCents = parseInt(btn.dataset.price, 10);
          if (priceEl) priceEl.textContent = formatMoney(currentUnitPriceCents);
          updateAddToCartPrice();
        });
      });

      /* Quantity stepper */
      root.querySelectorAll('[data-rizzy2-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var val = parseInt(qtyInput.value, 10) || 1;
          val = btn.dataset.rizzy2Qty === 'plus' ? val + 1 : Math.max(1, val - 1);
          qtyInput.value = val;
          updateAddToCartPrice();
        });
      });

      /* Manual quantity entry (typing directly into the number input) */
      if (qtyInput) {
        qtyInput.addEventListener('input', updateAddToCartPrice);
        qtyInput.addEventListener('change', updateAddToCartPrice);
      }

      /* Set the initial add-to-cart price in case quantity starts at something other than 1 */
      updateAddToCartPrice();
    }

    /* Thumbnail gallery */
    var mainImage = root.querySelector('[id^="RizzyV2MainImage-"]');
    root.querySelectorAll('[data-rizzy2-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-rizzy2-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage && thumb.dataset.full) {
          /* The main image has a srcset/sizes attribute for responsive
             loading. Browsers prioritize srcset over a JS-assigned .src,
             so both must be cleared or the swap silently does nothing. */
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumb.dataset.full;
          mainImage.alt = thumb.dataset.alt || mainImage.alt;
        }
      });
    });

    /* Thumbnail up/down scroll arrows */
    var thumbsList = root.querySelector('[data-rizzy2-thumbs]');
    root.querySelectorAll('[data-rizzy2-thumb-scroll]').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        if (!thumbsList) return;
        var dir = arrow.dataset.rizzy2ThumbScroll === 'up' ? -80 : 80;
        thumbsList.scrollBy({ top: dir, behavior: 'smooth' });
      });
    });
  }
})();
